import React, { Fragment, useEffect, useState } from "react";
import Blank from "./Blank";
import axios from "axios";
import connect from "react-redux/lib/connect/connect";
import { GetBettingHistories } from "../../common/actions/moreAction";
import { CancelBetting } from "../../common/actions/betAction";
import { logoutUser } from "../../common/actions/userActions";
import {
  isEmpty,
  showMessage,
  dateFormation,
  convertResultType,
  convertResultType_sero,
  convertTeamName,
  convertTypeString,
  convertTypeString_sero,
  convertClass,
  fixedNumber,
  isMobilePage,
  convertBettingHistory
} from "../../common/cores";
import Pagenation from "../common/Pagenation";
import HistoryDetail from "./HistoryDetail";
import MinigameHistory from "./hisotries/MInigameHistory";
import BetGameHistory from "./hisotries/BetGameHistory";
import Sportshistory from "./hisotries/Sportshistory";
import CasinoHistory from "./hisotries/CasinoHistory";
import { perPage } from "../../utils";

const bethistoryTabs = [
  {
    name: "스포츠",
    value: "prematch"
  },
  {
    name: "라이브",
    value: "live"
  },
  {
    name: "E 스포츠",
    value: "esport"
  },
  {
    name: "미니게임",
    value: "minigame"
  },
  {
    name: "벳게임",
    value: "betgame365"
  }
  // {
  //   name: '카지노',
  //   value: 'casino'
  // },
  // {
  //   name: '슬롯',
  //   value: 'slot'
  // }
];
const slotTableHead = {
  name: "slot",
  tableHead: [{
    headName: "번호", style: { width: "40px" }
  },
  { headName: "베팅시간", style: {} },
  { headName: "배팅금액", style: {} },
  { headName: "당첨금액", style: {} },
  { headName: "결과", style: {} },
  ]
};
const minigameTableHead = {
  name: "minigame",
  tableHead: [
    { headName: "번호", style: { width: "10%" } },
    { headName: "게임종류" },
    { headName: "회차번호" },
    { headName: "배팅상세" },
    { headName: "배팅시간", flexWrap: "wrap" },
    { headName: "배팅금" },
    { headName: "적중금" },
    { headName: "적중여부" }
  ]
};

const betgameTableHead = {
  name: "betgame365",
  tableHead: [

    { headName: "번호", style: { width: "40px" } },
    // { headName: "배팅아이디" },
    { headName: "리그명" },
    { headName: "배팅상세" },
    { headName: "배팅시간" },
    { headName: "배팅금" },
    { headName: "적중금" },
    { headName: "개별 적중여부", flexWrap: "wrap" },
    { headName: "전체 적중여부" }
  ]
};

const sportsTableHead = {
  name: "sports",
  tableHead: [
    { headName: "번호", style: { width: "40px" } },
    { headName: "배팅시간", style: { flexWrap: "wrap" } },
    { headName: "배당율" },
    { headName: "배팅금" },
    { headName: "예상적중금" },
    { headName: "경기결과" },
    { headName: "취소" }
  ]
};

const gameResults = [
  {
    name: "전체 내역",
    val: "",
    classNameName: "fa-check"
  },
  {
    name: "진행중",
    val: "waiting"
  },
  {
    name: "적중",
    val: "win"
  },
  {
    name: "미적중",
    val: "lose"
  }
];

const HistoriesContent = props => {
  const onChange = e => {
    const { value } = e.target; // 우선 e.target 에서 name 과 value 를 추출
    console.log(value)
    setHistories([]);
    setHistory({});
    setActive(value);
  };



  const { page, isAuthenticated } = props;

   const {curPage,totalPage} = page;
  const [active, setActive] = useState("prematch");
  const [gameResult, setGameResult] = useState("")
  const [history, setHistory] = useState({});
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [showHis, setShowHis] = useState(false);
  const [histories, setHistories] = useState([]);
  const [saveId, setSaveId] = useState("")
  const [popup, setPopup] = useState(false);

  const onPopup = () => {
    setPopup(!popup);
  }

  useEffect(() => {

    console.log("store", props.histories)
    setHistories(props.histories)
  }, [props.histories])

  const onHistory = (list, index) => {
    if (historyIndex === index) {
      // console.log("-------------------------")
      setHistoryIndex(-1);
    }
    else {
      setHistoryIndex(index);
      setHistory(list);
    }
  }

  const GetBettingHistories = (page, type, clear = false) => {
    if (isEmpty(type)) type = active;
    if (props.user.isAuthenticated) {
      props.GetBettingHistories({
        type,
        page,
        perPage: perPage,
        gameResult: gameResult,
        clear: clear
      })
    }
  }

  const onClickTab = (tabActive) => {
    if (active === tabActive)
      return;
    setHistories([]);
    setHistory({});
    setActive(tabActive);
  }

  const onGameResult = (val) => {
    setHistory({});
    setGameResult(val);
  }


  let tableHead = []
  switch (active) {
    case "minigame":
      tableHead = minigameTableHead;
      // console.log(tableHead);
      break;

    case "betgame365":
      tableHead = betgameTableHead;
      break;
    case "prematch":
    case "live":
    case "esport":
      tableHead = sportsTableHead;
      break;
    default:
      tableHead = slotTableHead;
      break;
  }

  useEffect(() => {
    setHistory({});
    setHistoryIndex(-1);
    GetBettingHistories(1, active);
  }, [isAuthenticated, gameResult, perPage])

  useEffect(() => {
    GetBettingHistories(1, active, true);
  }, [active])

  const showHisotry = () => {
    setShowHis(!showHis);
  }

  const cancelBetting = (data) => {
    props.CancelBetting(data)
  }

  return (
    <div>
      <div className="con_box10">
        <div className="date_wrap">
          <div className="date1">
            <ul>
              <li style={{ width: "100%" }}>
                <select
                  name="active"
                  id=""
                  className="select_input"
                  onChange={onChange}
                >
                  <option value="casino">카지노</option>
                  <option value="slot">슬롯</option>
                </select>
              </li>

              {/* <li className="no_bg"><a href="#"><span className="btn1_1">검색</span></a></li> */}
            </ul>
          </div>
        </div>
      </div>
      <div className="con_box10 bet_history_wrap1 overflow-auto">
        <table
          className="table_history"
          data-v-0b388a17=""
          style={{
            width: "100%",
            display: "table",
            minWidth: active !== "casino" && active !== "slot" && "635px"
          }}
        >
          <thead data-v-0b388a17="">
            <tr>
              {!isEmpty(tableHead) && (
                <Fragment>
                  {tableHead.tableHead.map((thead, key) => {
                    return (
                      <th
                        data-v-9dbb6d4c
                        className={`bet_history_title ${thead.className}`}
                        style={thead.style}
                        key={key}
                      >
                        {thead.headName}
                      </th>
                    );
                  })}
                </Fragment>
              )}
            </tr>
          </thead>

          <tbody data-v-0b388a17="">
            {!isEmpty(histories) &&
              histories.map((history, index) => {
                let fixture_ids = [];
                if (!isEmpty(history.odds))
                  history.odds.sort(function (a, b) {
                    return a.fixture_id - b.fixture_id;
                  });
                // const height = isEmpty(history.odds) ? 40 : history.odds.length * 40;
                const height = isEmpty(history.odds) ? 60 : 60;
                return active === "minigame" ?
                  <MinigameHistory
                    key={index}
                    history={history}
                    page={{ curPage, totalPage }}
                    index={index}
                  />
                  : (active === "betgame365" ?
                    <BetGameHistory
                      key={index}
                      history={history}
                      page={{ curPage, totalPage }}
                      index={index}
                    />
                    : (
                      active === 'slot' || active === 'casino' || active === 'hotelcasino' ? (
                        <CasinoHistory key={index} history={history} page={{ curPage, totalPage }} index={index} />
                      ) : (
                        <Sportshistory key={index} history={history} page={{ curPage, totalPage }} setSaveId={setSaveId} onPopup={onPopup} active={active} index={index} />
                      ))
                  )
              })
            }
          </tbody>
        </table>
      </div>
      <Pagenation
        page={curPage}
        totalPage={totalPage}
        getPage={GetBettingHistories}
        perPage={10}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated,
  page: state.page,
  user: state.user,
  histories: state.more.histories
});

export default connect(
  mapStateToProps,
  { CancelBetting, logoutUser, GetBettingHistories }
)(HistoriesContent);



// WEBPACK FOOTER //
// ./src/components/account/HistoriesContent.js